// Replace these placeholder URLs with your actual artwork images
export const artwork = {
  LOGO_IMAGE:
    'https://cdn.magicpatterns.com/uploads/gs1DukBrfjC5QJeyaSe2Xx/a1375-cropped-cropped-cropped-design_sans_titre__1_-removebg-preview-e1722436076517.png',
  LACTATION_ARTWORK:
    'https://cdn.magicpatterns.com/uploads/dxgjr6rU3oKiGJGdfd9GAa/42b17-photo-2024-10-08-08-59-13-fotor-2024100815319.webp',
  BIRTH_PREP_ARTWORK:
    'https://cdn.magicpatterns.com/uploads/7RZAjQgU7rvTrU6D4Sk7N6/WhatsApp_Image_2026-04-12_at_15.08.50.jpg',
  BREASTFEEDING_ARTWORK:
    'https://cdn.magicpatterns.com/uploads/9hgzH2Z7ypcyFtX6jg4eE5/cd116-whatsapp-image-2024-07-13-a-17.58.00_8947f229-fotor-20240820223122.webp',
  FAMILY_ARTWORK:
    'https://cdn.magicpatterns.com/uploads/wUQJczmzP84puWSSxhgAik/4eaa1-education-fotor-20240820222920.webp',
  PORTRAIT_IMAGE:
    'https://cdn.magicpatterns.com/uploads/9hgzH2Z7ypcyFtX6jg4eE5/cd116-whatsapp-image-2024-07-13-a-17.58.00_8947f229-fotor-20240820223122.webp',
}
